import { gql } from '@apollo/client';

export * from './softwareEscrowCreate.mutation.generated';

export const SOFTWARE_ESCROW_CREATE = gql`
  mutation softwareEscrowCreate($appId: ID!, $agreementForm: AgreementFormEnum!) {
    softwareEscrowCreate(input: { appId: $appId, softwareEscrowCreateParams: { agreementForm: $agreementForm } }) {
      success
      errors
      softwareEscrow {
        id
      }
    }
  }
`;
